module.exports = __webpack_public_path__ + "6f9995280bc08279c5549e7a50bd420a.png";